import React, { Component } from 'react';
import AsyncSelect from '../../components/Input/AsyncSelect';
import axios from '../../axios';

class LeanIXPicker extends Component {
    state = {
        page: {},
    }
    loadleanix = async (input, loadedOptions, { page }) => {
        try {
            if (input.length >= 3) {
                const response = await axios.get('api/LeanIX', { params: { leanIxName: input, page: this.state.page[input] || 1 } });
                this.setState({
                    page: { [input]: response.data.currentPage }
                })
                const options = response.data.items.map((res) => {
                    return {
                        //leanixuniqueid: res.leanIX_UniqueId,
                        //leanixname: res.leanIX_Name,
                        label: res.leanIxUniqueId,
                        value: res.leanIxName,
                        id: res.id,
                        name: res.leanIxUniqueId
                    }
                })

                return {
                    options: options,
                    hasMore: response.data.currentPage !== response.data.pageCount,
                    additional: {
                        page: page + 1,
                    },
                }
            } else {
                return {
                    options: [],
                    hasMore: false,
                    additional: {
                        page: page + 1,
                    },
                }
            }
        } catch (error) {
            this.setState({
                page: {}
            })
        }
    }
    render() {
        return (
            <AsyncSelect
                loadOptions={this.loadleanix}
                className={this.props.className}
                tooltipText={this.props.tooltipText}
                errorText={this.props.errorText}
                value={this.props.leanix}
                additional={{
                    page: 1
                }}
                handleChangeSingle={this.props.onChange}
                disabled={this.props.disabled}
                placeholder={this.props.placeholder}
                label={this.props.label}
                width={this.props.width ? this.props.width : "100%"}
                isClearable={true}
                showTooltip={true}
            />
        )
    }
}
export default LeanIXPicker;